import { Injectable } from '@angular/core';
import { HandleError, HttpErrorHandler, HttpUtility } from '@core/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { WoundOstomyQueueResponse } from '../model/wound-ostomy-queue-response.model';

const WOUND_OSTOMY_QUEUE_DATA_SERVICE = 'WoundOstomyQueueDataService';

@Injectable({
  providedIn: 'root'
})
export class WoundOstomyQueueDataService {
  private readonly apiBaseUrl: string;
  private handleError: HandleError;

  constructor(
    private httpClient: HttpUtility,
    private httpErrorHandler: HttpErrorHandler,
    shellService: ShellService
  ) {
    this.handleError = this.httpErrorHandler.createHandleError(WOUND_OSTOMY_QUEUE_DATA_SERVICE);
    this.apiBaseUrl = shellService.getBaseUrlFor(ProductNames.HomeHealth);
  }

  public getWoundOstomyQueueData(queryParams: string): Observable<WoundOstomyQueueResponse> {
    const url = `${this.apiBaseUrl}/WoundCareAdmissionsQueue/$query`;

    return this.httpClient
      .post<WoundOstomyQueueResponse>(url, queryParams)
      .pipe(catchError(this.handleError('getWoundOstomyQueueData', { count: 0, items: [] })));
  }

  public getRelevantData() {
    const url = `${this.apiBaseUrl}/WoundCareAdmissionsQueue/relevantData`;

    return this.httpClient
      .get<WoundOstomyQueueResponse>(url)
      .pipe(catchError(this.handleError('getWoundOstomyQueueData', { states: [], providers: [] })));
  }

  public getReferralStatusReasonsData(tenantId: string,
    entityType: string,) {
    const url = `${this.apiBaseUrl}/tenants/${tenantId}/references?entity=${entityType}`;
    return this.httpClient
      .get<WoundOstomyQueueResponse>(url)
      .pipe(catchError(this.handleError('getWoundOstomyQueueData', { reasons: [] })));
  }

  public removeWoundOstomyQueueRecords(recordIdList: string[]) {
    const url = `${this.apiBaseUrl}/WoundCareAdmissionsQueue/delete`;

    return this.httpClient
      .delete<WoundOstomyQueueResponse>(url, { body: recordIdList })
      .pipe(catchError(this.handleError('getWoundOstomyQueueData')));
  }
}
